<template>
    <div class="mb25">
        <label class="order__input-label">Ваш адрес</label>
        <select @change="changeAddress()" v-model="localDefault_address_id" class="order__input order__input--select">
            <option v-for="address in localAddress" :value="address.id">{{ address.street }}, д.{{ address.house }}, стр.{{ address.building }}, кв.{{ address.flat }}</option>
        </select>
        <button v-if="localDefault_address_id != 0" class="btn btn--blue btn--small" @click.prevent="newAddress">Новый адрес</button>
        <button v-if="localDefault_address_id != 0" class="btn btn--red btn--small" @click.prevent="showDelete">Удалить адрес</button>
        <a style="color: #c8242d;" v-if="show_delete_link===true" href="#" @click.prevent="delAddress">Да</a>
        <a v-if="show_delete_link===true" href="#" @click.prevent="hideDelete">Нет</a>
        <label class="order__input-label" for="AddressForm_street">Улица</label>
        <div class="order__input-wr">
            <input v-model="localCurrent_address.street" v-on:blur="updateData()" class="order__input" id="AddressForm_street" name="AddressForm[street]" type="text"/>
            <svg class="order__required" width="15" height="15">
                <use xlink:href="#icon-asterisk"></use>
            </svg>
        </div>
        <label class="order__input-label" for="AddressForm_house">Дом</label>
        <div class="order__input-wr">
            <input v-model="localCurrent_address.house" v-on:blur="updateData()" class="order__input" id="AddressForm_house" name="AddressForm[house]" type="text"/>
            <svg class="order__required" width="15" height="15">
                <use xlink:href="#icon-asterisk"></use>
            </svg>
        </div>
        <label class="order__input-label" for="AddressForm_building">Строение</label>
        <div class="order__input-wr">
            <input v-model="localCurrent_address.building" v-on:blur="updateData()" class="order__input" id="AddressForm_building" name="AddressForm[building]" type="text"/>
        </div>
        <label class="order__input-label" for="AddressForm_flat">Квартира/офис</label>
        <div class="order__input-wr">
            <input v-model="localCurrent_address.flat" v-on:blur="updateData()" class="order__input" id="AddressForm_flat" name="AddressForm[flat]" type="text"/>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    export default {
        name: "address-form",
        props: {
            address: {
                default () {return [{street: ''}]},
                type: Array
            },
            default_address_id: {
                default: 0,
                type: Number
            },
            current_address: {
                default () {return {street: ''};},
                type: Object
            }
        },
        data () {
            return {
                localAddress : this.address,
                localDefault_address_id : this.default_address_id,
                localCurrent_address : this.current_address,
                show_delete_link: false
            }
        },
        methods: {
            getAddress () {
                let params = new URLSearchParams();
                params.append('param', 'deliv_address');
                axios.get('/rest/profile', {params})
                    .then((response) => {
                        const data = JSON.parse(response.data);
                        if(data.length !== 0) {
                            this.localAddress = data;
                            this.localDefault_address_id = data[0].id;
                            this.localCurrent_address = this.localAddress[0];
                        } else {
                            this.localAddress = {};
                            this.localDefault_address_id = 0;
                            this.localCurrent_address = {};
                        }

                    }).catch(error => console.log(error))

            },
            changeAddress () {
                let params = new URLSearchParams();
                params.append('id', this.localDefault_address_id);
                params.append('action', 'set_default_address');
                this.$store.commit('clearError')
                this.$store.commit('setLoading', true)
                axios.put('/rest/profile', params)
                    .then((response) => {
                        this.getAddress();
                        this.$store.commit('setLoading', false)
                    }).catch(error => {console.log(error);this.$store.commit('setLoading', false)})
            },
            newAddress () {
                this.localDefault_address_id = 0;
                this.localCurrent_address = {};
                this.updateData();
            },
            delAddress () {
                let params = new URLSearchParams();
                params.append('action', 'delete_address');
                params.append('id', this.localDefault_address_id);
                axios.delete('/rest/profile', {data:params})
                    .then((response) => {
                        this.getAddress();
                        this.show_delete_link = false;
                    }).catch(error => console.log(error))
            },
            updateData () {
                let params = new URLSearchParams();
                params.append('action', 'update_address');
                params.append('id', this.localDefault_address_id);
                params.append('value', JSON.stringify(this.localCurrent_address));
                axios.put('/rest/profile', params)
                    .then((response) => {
                        this.getAddress();
                    }).catch(error => console.log(error))
            },
            showDelete () {
                this.show_delete_link = true;
            },
            hideDelete () {
                this.show_delete_link = false;
            },
        },
        created () {
            this.getAddress();
        }
    }
</script>

<style scoped>
    select {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
    }
</style>
